import InteractiveButton from '../Button/InteractiveButton';
import { CloseCircle } from '../flyfishIcons/icons';
import './Chip2.scss';
import React from 'react';
import styled from 'styled-components';

type ChipProps = {
	className?: string;
	label: JSX.Element | string;
	icon?: JSX.Element;
	onDelete?: (event: any) => void;
	onClick?: (event: any) => void;
};

const CHIP2 = styled.div`
	&.ff-chip-2 {
		display: flex;
		align-items: center;
		width: fit-content;
		font-size: 12px;
		padding: 0 4px 0 6px;
		border-radius: 6px;
		background-color: var(--black-5);
		border: 1px solid var(--black-20);
		gap: 4px;
		color: var(--black);
		transition: all 0.2s ease-out;

		&.focused:not(.error) {
			border-color: var(--violet-600);
			outline: 1px solid var(--violet-600);
			cursor: pointer;
		}

		&:hover:not(.focused) {
			border-color: var(--black-40);
			cursor: pointer;
		}

		&.error {
			background-color: var(--vibrant-pink-50);
			border-color: var(--vibrant-pink-200);

			&:hover {
				border-color: var(--vibrant-pink-400);
			}

			&.focused {
				border-color: var(--vibrant-pink-400);
				outline: 1px solid var(--vibrant-pink-400);
				cursor: pointer;
			}

			.close-icon {
				.interactive-button {
					.MuiIconButton-root {
						padding: 0;

						&.hoverable-none {
							color: var(--vibrant-pink-300);

							&:not(.Mui-disabled):hover {
								color: var(--vibrant-pink-400);
							}

							&:not(.Mui-disabled):focus,
							&:not(.Mui-disabled):active {
								color: var(--vibrant-pink-400);
							}
						}
					}
				}
			}
		}

		.interactive-button {
			.MuiIconButton-root {
				padding: 0;
			}
		}
	}
`;

const Chip2 = ({
	label,
	icon,
	onDelete,
	onClick,
	className = '',
}: ChipProps) => {
	return (
		<CHIP2 className={`ff-chip-2 ${className}`} onClick={onClick}>
			{icon}
			<span className='ff-chatbot-body1'>{label}</span>
			<div className='close-icon'>
				<InteractiveButton
					hoverable='none'
					icon={<CloseCircle />}
					onClick={onDelete}
				/>
			</div>
		</CHIP2>
	);
};

export default Chip2;
